import { GridProps } from "@mui/material";
import React, { FC, PropsWithChildren } from "react";
import { Card } from "./Card";
import * as Styled from "./CardRow.styled";

type CardRowProps = PropsWithChildren<GridProps>;

export const CardRow: FC<CardRowProps> = ({ children, ...gridProps }) => (
    <Styled.CardRow {...gridProps}>
        {React.Children.map(children, (child, key) => (
            <Card key={key}>{child}</Card>
        ))}
    </Styled.CardRow>
);
